<template>
  <b-col
    :md="get_config('integration.welfare') ? 3 : 6"
  >
    <b-row>
      <b-col md="6">
        <div class="h6 site-footer__title">Chi siamo</div>
        <ul class="site-footer__links">
          <li class="site-footer__link">
            <router-link :to="{ name: 'about' }">
              {{ get_config("site.brand") }} di Salabam Solutions
            </router-link>
          </li>
          <li class="site-footer__link">
            <a href="https://www.salabamsolutions.com" target="_blank">
              Salabam Solutions
            </a>
          </li>
        </ul>
      </b-col>
      <b-col md="6" v-if="!get_config('integration.welfare')">
        <div class="h6 site-footer__title">Termini e condizioni</div>
        <ul class="site-footer__links">
          <li class="site-footer__link">
            <router-link :to="{ name: 'terms' }">
              Condizioni d'uso
            </router-link>
          </li>
          <li class="site-footer__link">
            <a :href="site.urlPrivacy" target="_blank"> Privacy Policy </a>
          </li>
          <li class="site-footer__link">
            <a :href="site.urlCookiePolicy" target="_blank"> Cookie policy </a>
          </li>
        </ul>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import { is_authenticated } from "@/utilities/";

export default {
  name: "site-footer",
  components: {},
  data() {
    return {
      site: this.$config.site,
    };
  },
  methods: { is_authenticated },
};
</script>

<style lang="scss"></style>
